//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axiosApi from '@/request/index'
import {getUrlparams,toCopy} from '@/utils/util.js'
import homeTip from '@/components/homeTip'

export default {
  name: "contractDetail",
  components: {
    homeTip
  },
  data() {
    return {
      toCopy,
      reasonShow:false,
      popReason:'',
      reasonList:[
      ],
      basicForm: {
        contractName: '',
        channelStr: '',
        supplierName: '',
        purchaseOrderGoodsDeliveryList: [],
        purchaseOrderSn: '',
        paymentName: '',
        remark: '',
        contractFile:[],
        contractPDF:[],
        taxRate:'',
        purchaseStatus:'',
        contractId:'',
        materialFeeUndertake:'',
        secondPaymentTypeId:'',
      },
      dataList:{},
      qualityOrderId:'',
      qualityResultId:'',
      purchaseOrderId:'',
      fileList:[],
    }
  },
  created() {
  },
  mounted() {
    if (this.$route.query.purchaseOrderId) {
      this.purchaseOrderId = this.$route.query.purchaseOrderId
      this.getContract()
    }
  },
  methods: {
    getContract() {
      var queryParams = {purchaseOrderId: this.purchaseOrderId}
      axiosApi.queryPurchaseContract(queryParams).then(response => {
        var data = response.content;
        if(data.purchaseOrderGoodsDeliveryList&&data.purchaseOrderGoodsDeliveryList.length>0){
          data.purchaseOrderGoodsDeliveryList.forEach((item)=>{
            if(item.orderNum&&item.unitContractPrice){
              item.count = (item.orderNum*item.unitContractPrice).toFixed(2)
            }else{
              item.count = 0
            }
          })
        }
        for (var ind in data) {
          var val = data[ind] != null ? data[ind] : ""
          this.$set(this.basicForm, ind, val)
        }
        var channelStr = '';
        if (this.basicForm.firstDeptName) {
          channelStr += this.basicForm.firstDeptName
        }
        if (this.basicForm.secondDeptName) {
          channelStr += '/' + this.basicForm.secondDeptName
        }
        this.$set(this.basicForm, 'channelStr', channelStr)

        var paymentName = '';
        if (this.basicForm.firstPaymentTypeName) {
          paymentName += this.basicForm.firstPaymentTypeName
        }
        if (this.basicForm.secondPaymentTypeName) {
          paymentName += '/' + this.basicForm.secondPaymentTypeName
        }
        if(data.contractFile&&data.contractFile.length>0){
          data.contractFile.forEach((item)=>{
            this.fileList.push({url:item})
          })
        }
        // if(data.contractFile&&data.contractFile.length>0){
        //   this.pictureList = data.contractFile.map((item)=>{
        //     return {url:item,deg:0}
        //   })
        // }
        this.$set(this.basicForm, 'paymentName', paymentName)
        // this.totalDic = {"数量":data.orderNumSum||0,"标费":data.totalBidFeeSum||0,"合同总价":data.totalContractPriceSum||0},
        //   this.$refs.commonTableRef2.reloadDone()
      }).catch(error => {
      })
    },
    showDetail(remark){
      this.popReason = remark
      this.reasonShow = true
    },
    toMore(){
      this.$router.push({name:'qualityOrderDetailMore'})
    },
    toBase(){
      this.$router.push({name:'qualityOrderDetailBase'})
    },
    toAddReason(){
      this.$router.push({name:'addReason',type:2})
    },
    openPdf(item){
      window.location.href = item
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/purchase/contractDetail.vue